import api from './index'

export default {
  login: user => api.post('auth', user),
  me: () => api.get('auth/me'),
  assignPassword: user => api.put(`auth/assign-password/${user.id}`, user)
}
